import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/9/thumb-landscape.jpg"

const Post9 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Chloe／パラティ／30 x21 x11cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          フランス・パリで1952年に創業された「Chloé (クロエ) 」。さりげなく上品な存在感のバッグは、年齢やシーンを問わず使いやすく、幅広い世代の女性から支持を得ています。今回はそんなクロエの人気バッグ10選をご紹介します！
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ドリュー（Drew）</h2>
          <p>2014年に発表されて以来、世界中のファッショニスタや海外セレブに愛用され、いまやクロエを代表するバッグとなった「ドリュー」。ころんとした丸みをおびたフォルムは、シンプルですが女性らしさを引き立たせるようなフェミニンな魅力に溢れています。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/2.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Chloe／ドリュー／17 x15 x6cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/3.jpg" alt="" />
            <span className="text-center">Chloe／ドリュー／28 x25 x10cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/4.jpg" alt="" />
            <span className="text-center">Chloe／ドリュー／21 x16 x7cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
          <h2>クロエC（Chloe C）</h2>
          <p>2018年スプリングコレクションで発表した「クロエ C」は、四角いフォルムに大胆な“C”のメタルパーツが印象的。シンプルながらクロエらしいフェミニンなデザインは、コーデに華を添えてくれます。小ぶりのバッグはパーティー用にもピッタリ。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/6.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Chloe／クロエC／16 x15 x5cm</span>          
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/7.jpg" alt="" />
            <span className="text-center">Chloe／クロエC／16 x13 x5cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/8.jpg" alt="" />
            <span className="text-center">Chloe／クロエCクロスバッグ／20 x13 x5cm</span> 
          </figure>
        </div>    
        <div className="text-max-width">
          <h2>ウッディ（Woody）</h2>
          <p>インスタグラマーの間で人気沸騰中の「ウッディ」は、クロエロゴのリボンとキャンバス素材のバランス感が絶妙。両サイドに施されたレザーの高級感で、カジュアルコーデはもちろん、ワンピースなどのキレイめアイテムにもよく合います。</p>
        </div>     
        <div className="img-two-cloumn">    
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/10.jpg" alt="" />
          </figure>   
        </div>   
        <span className="text-center">Chloe／トートバッグ／43 x33 x11cm</span>        
        <Link to="https://laxus.co/app/pc/bags/chloe" className="view-all-button">
          クロエのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>エルシー（Elsie）</h2>
          <p>十字形の留め具のデザインと華奢なチェーンのストラップが女性らしい印象の「エルシー」。バッグのフォルムはかっちりとしているので、カジュアルやモードな服装にも幅広く合わせやすいのが魅力です。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/13.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/14.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Chloe／エルシー／20 x15 x8cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/15.jpg" alt="" />
            <span className="text-center">Chloe／エルシー／24 x21 x12cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/16.jpg" alt="" />
            <span className="text-center">Chloe／エルシー／20 x15 x8cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
        <h2>アリス（Alice）</h2>
          <p>「アリス」は、台形型のすっきりとしたフォルムにアンティークなゴールドの金具が上質感のある大人のオシャレにぴったり。サイズ展開とカラーバリエーションも豊富で、ファッションによっていろいろなデザインを選べるのが嬉しいポイント。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/17.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/18.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Chloe／アリス／36 x14 x18cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/19.jpg" alt="" />
            <span className="text-center">Chloe／アリス／29 x15 x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/20.jpg" alt="" />
            <span className="text-center">Chloe／アリス／29 x16 x15cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>パラティ（Paraty）</h2>
          <p>三角形のフォルムとハンドルから繋がるレザーロープが独特の存在感を放つ「パラティ」。もともとマチは広めに取られていますが、サイドに付いているゴールドの金具を外すと、さらにマチを広げることができるので収納力も抜群♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/21.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/22.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Chloe／パラティ／37 x23 x14cm</span>    
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/23.jpg" alt="" />
            <span className="text-center">Chloe／パラティ／30 x21 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/24.jpg" alt="" />
            <span className="text-center">Chloe／パラティ／36 x23 x12cm</span>
          </figure>
        </div> 
        <div className="text-max-width">
          <h2>マーシー（Marcie）</h2>
          <p>バッグ前面に施された刺繍と、曲線のフォルムがエレガンスで女性らしい印象の「マーシー」。肌触りの良い上質なレザーと荷物をすっきりと収めてくれる優れた収納力はデイリーに活躍してくれそう。</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/25.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/26.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">Chloe／マーシー／44 x35 x14cm</span>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/27.jpg" alt="" />
            <span className="text-center">Chloe／マーシー／36 x27 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/28.jpg" alt="" />
            <span className="text-center">Chloe／マーシー／35 x22 x10cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/chloe" className="view-all-button">
          クロエのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>ベイリー（BAYLEE）</h2>
          <p>マットなレザーが上質感たっぷりな「ベイリー」。存在感のある太めのショルダーストラップの付いたデザインは、カジュアルな服装にも合わせやすく、幅広く活躍してくれること間違いなしです♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/29.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/30.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">Chloe／ベイリー／24 x19 x11cm</span>             
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/31.jpg" alt="" />
            <span className="text-center">Chloe／ベイリー／26 x20 x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/32.jpg" alt="" />
            <span className="text-center">Chloe／ベイリー／26 x20 x14cm</span> 
          </figure>       
        </div>
        <div className="text-max-width">
          <h2>フェイ（Faye）</h2>
          <p>シンプルでムダの無いフォルムの「フェイ」は、カジュアルにも、パーティーシーンにもマッチするバッグ。フェイを象徴するゴールドのリングループとチェーンがフェミニンな印象を演出してくれます。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/33.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/34.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">Chloe／フェイ／39 x31 x14cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/35.jpg" alt="" />
            <span className="text-center">Chloe／フェイ／33 x25 x14cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/36.jpg" alt="" />
            <span className="text-center">Chloe／フェイ／24 x13 x3cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>マイロ（MILO）</h2>
          <p>「マイロ」を特徴づけるモチーフであるサイドジッパーは、デザインのアクセントになるだけでなく、開けることでより多くの荷物を収納することができます。持ち手が長めなので肩にかけやすく、使いやすさ抜群のバッグです♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/37.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/38.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">Chloe／マイロ／33 x29 x15cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/39.jpg" alt="" />
            <span className="text-center">Chloe／マイロ／33 x29 x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/40.jpg" alt="" />
            <span className="text-center">Chloe／マイロ／33 x30 x16cm</span> 
          </figure>
        </div>
        <div className="text-two-cloumn">
          <h2>ドリュー×エコファーコーデ</h2>
          <p>エコファーのロングコートを主役にしたシンプルコーデのワンポイントにドリューを合わせれば、上品な大人のカジュアルスタイルに早変わり♪</p>
        </div> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/41.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/9/42.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">Chloe／ドリュー／21 x16 x7cm</span>                                       
        <Link to="https://laxus.co/app/pc/bags/chloe" className="view-all-button">
          クロエのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post9

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 9}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
